import React, { useState } from "react";
import "./ContactSection.css";

export default function ContactSection() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const res = await fetch("https://agepcoatings.com/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      const data = await res.json();
      alert(data.message || "Message sent successfully!");
    } catch (error) {
      console.error(error);
      alert("Something went wrong!");
    }
  };

  return (
    <section className="contact-section mb-5" id="contact">
      <h2>Let’s Talk</h2>
      <p className="subtitle">We’re here to help</p>

      <div className="contact-container">
        {/* Map & Address */}
        <div
          className="contact-info"
          style={{ backgroundColor: "rgba(241, 241, 241, 1)" }}
        >
          <iframe
            title="EAC International LLC"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2925.327705308012!2d-106.24030982404247!3d42.84481317115204!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8760b9e9f00d0993%3A0xd077893ac6b75b75!2s5830%20E%202nd%20St%20Ste.%207000%2C%20Casper%2C%20WY%2082609%2C%20USA!5e0!3m2!1sen!2sin!4v1767355572569!5m2!1sen!2sin"
            style={{
              border: 0,
              width: "100%",
              height: "100%",
              minHeight: "250px",
            }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />

          <p>
            EAC International LLC
            <br />
            5830 E 2nd Street Ste 7000 Casper, WY 82609
          </p>
          <p>📞 +1-307-301-8385</p>
        </div>

        {/* Contact Form */}
        <form
          className="contact-form"
          style={{ backgroundColor: "rgba(241, 241, 241, 1)" }}
          onSubmit={handleSubmit}
        >
          <div className="form-row">
            <input
              type="text"
              name="name"
              placeholder="Enter your name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-row">
            <input
              type="text"
              name="phone"
              placeholder="Enter your phone number"
              value={formData.phone}
              onChange={handleChange}
            />
            <input
              type="text"
              name="subject"
              placeholder="Enter subject"
              value={formData.subject}
              onChange={handleChange}
            />
          </div>
          <textarea
            name="message"
            placeholder="Enter your message"
            rows="5"
            value={formData.message}
            onChange={handleChange}
          ></textarea>
          <button type="submit" className="submit-btn">
            Submit
          </button>
        </form>
      </div>
    </section>
  );
}
